(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-tabs"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  const tabsNav = document.querySelectorAll(".tab-common-nav-sec");
  const contentsTabs = document.querySelectorAll(".tab-content-row-data");

  // 100px offset scroll (SECTION level)
  function scrollToSection(element, offset = 100) {
    const section = element.closest("section");
    if (!section) return;

    const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

  function openTab(tabHandle, shouldScroll = false) {

    const targetContent = document.querySelector(
      '.tab-content-row-data[data-content="' + tabHandle + '"]'
    );

    const targetTab = document.querySelector(
      '.tab-common-nav-sec[data-tab="' + tabHandle + '"]'
    );

    if (!targetContent || !targetTab) return;

    // Remove active
    tabsNav.forEach(tab => tab.classList.remove("active"));
    contentsTabs.forEach(content => content.classList.remove("active"));

    // Add active
    targetTab.classList.add("active");
    targetContent.classList.add("active");

    // Scroll only when required (hash case)
    if (shouldScroll) {
      setTimeout(() => {
        scrollToSection(targetContent, 100);
      }, 200);
    }
  }

  // ✅ Tab click → NO SCROLL
  tabsNav.forEach(tab => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      const tabHandle = this.getAttribute("data-tab");

      history.pushState(null, null, "#" + tabHandle);

      openTab(tabHandle, false); // false = no scroll
    });
  });

  // ✅ On page load (if hash present → scroll)
  function handleHashOnLoad() {
    const hash = window.location.hash.replace("#", "");

    if (hash) {
      openTab(hash, true); // true = scroll
    } else {
      const firstTab = tabsNav[0]?.getAttribute("data-tab");
      if (firstTab) openTab(firstTab, false);
    }
  }

  handleHashOnLoad();

  // ✅ On hash change (manual change)
  window.addEventListener("hashchange", function () {
    const hash = window.location.hash.replace("#", "");
    if (hash) openTab(hash, true);
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-redesign"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".look-book-link-add");
  const contents = document.querySelectorAll(".product-tab-lookbook-js");

  function scrollToSection(element, offset = 100) {
    const section = element.closest("section");
    if (!section) return;

    const top = section.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: "smooth"
    });
  }

  function refreshSlickSlider(container) {
    if (typeof jQuery === "undefined") return;

    const $ = jQuery;

    $(container)
      .find(".slick-slider")
      .each(function () {
        if ($(this).hasClass("slick-initialized")) {
          $(this).slick("setPosition");
        }
      });
  }

  function openTab(tabHandle, shouldScroll = false) {

    const targetContent = document.querySelector(
      `.product-tab-lookbook-js[data-content="${tabHandle}"]`
    );

    const targetTab = document.querySelector(
      `.look-book-link-add[data-tab="${tabHandle}"]`
    );

    if (!targetContent || !targetTab) return;

    tabs.forEach(tab => tab.classList.remove("active"));
    contents.forEach(content => content.classList.remove("active"));

    targetTab.classList.add("active");
    targetContent.classList.add("active");

    setTimeout(() => {
      refreshSlickSlider(targetContent);
    }, 100);

    if (shouldScroll) {
      setTimeout(() => {
        scrollToSection(targetContent, 100);
      }, 200);
    }
  }

  // Tab click
  tabs.forEach(tab => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const tabHandle = this.dataset.tab;

      openTab(tabHandle, false);

      // Ensure URL stays clean
      history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.search
      );

      return false;
    });
  });

  // Open first available tab on load
  if (tabs.length) {
    openTab(tabs[0].dataset.tab, false);
  }

});


document.addEventListener('click', function (e) {
  const anchor = e.target.closest('a.scroll-anchor-click-sec');

  if (!anchor) return;

  const id = anchor.getAttribute('href');

  if (!id || id === '#') return;

  const target = document.querySelector(id);

  if (!target) return;

  e.preventDefault();

  const offset = 70;

  const targetTop =
    target.getBoundingClientRect().top +
    window.scrollY -
    offset;

  window.scrollTo({
    top: targetTop,
    behavior: 'smooth'
  });

  // URL hash update without browser's default jump
  history.pushState(null, '', id);
});

document.querySelector('.open-toggle-accord')?.addEventListener('click', function (e) {
  e.preventDefault();

  const head = document.querySelector('#sizeBlockAccord .accordion_head');

  head?.classList.add('arrow_down');

  const arrow = head?.querySelector('.acc__arrow');
  arrow?.classList.add('arrow_down');

  const body = head?.nextElementSibling;

  body?.style.setProperty('display', 'block', 'important');
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute('href'));

    if (target) {
      const offsetTop =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        150;

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });

      // Remove hash from URL
      history.replaceState(null, null, window.location.pathname);
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".look-book-link-add");
  const contents = document.querySelectorAll(".product-tab-lookbook-js");

  function scrollToSection(element, offset = 100) {
    const section = element.closest("section");
    if (!section) return;

    const top = section.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: "smooth"
    });
  }

  function refreshSlickSlider(container) {
    if (typeof jQuery === "undefined") return;

    const $ = jQuery;

    $(container)
      .find(".slick-slider")
      .each(function () {
        if ($(this).hasClass("slick-initialized")) {
          $(this).slick("setPosition");
        }
      });
  }

  function openTab(tabHandle, shouldScroll = false) {

    const targetContent = document.querySelector(
      `.product-tab-lookbook-js[data-content="${tabHandle}"]`
    );

    const targetTab = document.querySelector(
      `.look-book-link-add[data-tab="${tabHandle}"]`
    );

    if (!targetContent || !targetTab) return;

    tabs.forEach(tab => tab.classList.remove("active"));
    contents.forEach(content => content.classList.remove("active"));

    targetTab.classList.add("active");
    targetContent.classList.add("active");

    setTimeout(() => {
      refreshSlickSlider(targetContent);
    }, 100);

    if (shouldScroll) {
      setTimeout(() => {
        scrollToSection(targetContent, 100);
      }, 200);
    }
  }

  // Tab click
  tabs.forEach(tab => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const tabHandle = this.dataset.tab;

      openTab(tabHandle, false);

      // Ensure URL stays clean
      history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.search
      );

      return false;
    });
  });

  // Open first available tab on load
  if (tabs.length) {
    openTab(tabs[0].dataset.tab, false);
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-tab-collection"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  const tabsNav = document.querySelectorAll(".tab-common-nav-sec");
  const contentsTabs = document.querySelectorAll(".tab-content-row-data");

  // 100px offset scroll (SECTION level)
  function scrollToSection(element, offset = 100) {
    const section = element.closest("section");
    if (!section) return;

    const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

  function openTab(tabHandle, shouldScroll = false) {

    const targetContent = document.querySelector(
      '.tab-content-row-data[data-content="' + tabHandle + '"]'
    );

    const targetTab = document.querySelector(
      '.tab-common-nav-sec[data-tab="' + tabHandle + '"]'
    );

    if (!targetContent || !targetTab) return;

    // Remove active
    tabsNav.forEach(tab => tab.classList.remove("active"));
    contentsTabs.forEach(content => content.classList.remove("active"));

    // Add active
    targetTab.classList.add("active");
    targetContent.classList.add("active");

    // Scroll only when required (hash case)
    if (shouldScroll) {
      setTimeout(() => {
        scrollToSection(targetContent, 100);
      }, 200);
    }
  }

  // ✅ Tab click → NO SCROLL
  tabsNav.forEach(tab => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      const tabHandle = this.getAttribute("data-tab");

      history.pushState(null, null, "#" + tabHandle);

      openTab(tabHandle, false); // false = no scroll
    });
  });

  // ✅ On page load (if hash present → scroll)
  function handleHashOnLoad() {
    const hash = window.location.hash.replace("#", "");

    if (hash) {
      openTab(hash, true); // true = scroll
    } else {
      const firstTab = tabsNav[0]?.getAttribute("data-tab");
      if (firstTab) openTab(firstTab, false);
    }
  }

  handleHashOnLoad();

  // ✅ On hash change (manual change)
  window.addEventListener("hashchange", function () {
    const hash = window.location.hash.replace("#", "");
    if (hash) openTab(hash, true);
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal-promo"] && !Shopify.designMode) return;
  try {
    
    function hasPromoModalShown() {
  return sessionStorage.getItem("promoModalShownNew") === "yes";
}

function showPromoModal() {
  var modal = document.getElementById("promoModal");
  if (!modal) {
    return;
  }

  modal.style.display = "flex";
  document.body.style.overflow = "hidden";

  // Mark as shown
  sessionStorage.setItem("promoModalShownNew", "yes");
}

document.addEventListener("DOMContentLoaded", function () {

  var modalPromo = document.getElementById("promoModal");
  if (!modalPromo) {
    return;
  }


  // Show only once per session
  if (!hasPromoModalShown()) {
    showPromoModal();
  }

  // Close button
  var closeBtn = modalPromo.querySelector(".modal_close_promo");
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      modalPromo.style.display = "none";
      document.body.style.overflow = "";
    });
  } else {
    console.log("⚠️ Close button not found");
  }

  // Click outside to close
  var overlay = modalPromo.querySelector(".universal-modal__overlay");
  if (overlay) {
    overlay.addEventListener("click", function () {
      modalPromo.style.display = "none";
      document.body.style.overflow = "";
    });
  } else {
    console.log("⚠️ Overlay not found");
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["time-counter"] && !Shopify.designMode) return;
  try {
    
function initCountdown() {
  const bannerEl = document.getElementById('banner-section');
  if (!bannerEl) return;

  const rawDate = bannerEl.dataset.endDate; // "2025-12-31"
  const rawTime = bannerEl.dataset.endTime || '23:59'; // "18:30"

  if (!rawDate) {
    console.error('Countdown: End date missing');
    return;
  }

  // 🔥 SAFE date + time parsing (all browsers)
  const [year, month, day] = rawDate.split('-').map(Number);
  const [hour, minute] = rawTime.split(':').map(Number);

  const endDate = new Date(year, month - 1, day, hour, minute, 0);

  console.log('Countdown End →', endDate.toString());

  setupDigitDOM();
  startCountdown(endDate);
}

// Add digit spans 0–9
function setupDigitDOM() {
  const digitElement = document.querySelectorAll('.banner-countdown__digit');

  digitElement.forEach((el) => {
    const digitWrapper = document.createElement('span');
    digitWrapper.classList.add('banner-countdown__digit-num');

    for (let x = 0; x <= 9; x++) {
      const digitItem = document.createElement('span');
      digitItem.innerText = x;
      digitWrapper.appendChild(digitItem);
    }

    el.innerHTML = '';
    el.appendChild(digitWrapper);
  });
}

// Start countdown interval
function startCountdown(endDate) {
  setInterval(() => {
    makeCountdown(endDate, false);
  }, 1000);
}

// Main countdown math
function makeCountdown(endTime, hideDaysIfEmpty = false) {
  const endTimeStamp = endTime.getTime() / 1000;
  const nowStamp = Date.now() / 1000;

  let timeLeft = endTimeStamp - nowStamp;

  let days = Math.floor(timeLeft / 86400);
  let hours = Math.floor((timeLeft % 86400) / 3600);
  let minutes = Math.floor((timeLeft % 3600) / 60);
  let seconds = Math.floor(timeLeft % 60);

  if (timeLeft < 0) {
    days = hours = minutes = seconds = 0;
  }

  hours = hours.toString().padStart(2, '0');
  minutes = minutes.toString().padStart(2, '0');
  seconds = seconds.toString().padStart(2, '0');

  if (days === 0 && hours === "00" && minutes === "00" && seconds === "00") {
    const timerBlock = document.querySelector('.top-announce-timer-main');
    if (timerBlock) timerBlock.classList.add('timer-ended');
  }

  if (days <= 0 && hideDaysIfEmpty) {
    const dayElement = document.querySelector('#timer-day');
    if (dayElement) dayElement.style.display = 'none';
  } else {
    updateCountdown(days, 'timer-day');
  }

  updateCountdown(hours, 'timer-hour');
  updateCountdown(minutes, 'timer-minute');
  updateCountdown(seconds, 'timer-second');
}

// Update UI animation
function updateCountdown(value, elementId) {
  const element = document.querySelector(`#${elementId}`);
  if (!element) return;

  const firstDigitElement = element.querySelector('.banner-countdown__digit-first > span');
  const secondDigitElement = element.querySelector('.banner-countdown__digit-second > span');

  if (!firstDigitElement || !secondDigitElement) return;

  const digitHeight = secondDigitElement.offsetHeight / 10;
  let digits = value.toString().padStart(2, '0').split('').map(Number);

  if (elementId === 'timer-day') {
    const hundredDigit = element.querySelector('.banner-countdown__digit-hundred > span');
    if (value >= 100 && hundredDigit) {
      const [h, f, s] = value.toString().split('').map(Number);
      hundredDigit.style.transform = `translateY(-${h * digitHeight}px)`;
      digits = [f, s];
    }
  }

  firstDigitElement.style.transform = `translateY(-${digits[0] * digitHeight}px)`;
  secondDigitElement.style.transform = `translateY(-${digits[1] * digitHeight}px)`;
}

document.addEventListener('DOMContentLoaded', initCountdown);
document.addEventListener('shopify:section:load', initCountdown);

  } catch(e) { console.error(e); }
})();
})();
